import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import MobileMenu from "../MobileMenu/index.js";
import SocialIconLink from "../common/SocialIconLink.jsx";
import { navItems, socialLinks } from "../../data/navigation.js";
import transparentLogo from "../../assets/generated/magdump-logo-transparent.webp";

export default function SiteNav() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [homeHeroOwnsBrand, setHomeHeroOwnsBrand] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") {
      setHomeHeroOwnsBrand(false);
      return undefined;
    }

    let animationFrame = 0;
    const updateBrandState = () => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(() => {
        const hero = document.querySelector(".hero");
        const nav = document.querySelector(".site-nav");
        if (!hero || !nav) {
          setHomeHeroOwnsBrand(false);
          return;
        }
        const heroBottom = hero.getBoundingClientRect().bottom;
        const navHeight = nav.getBoundingClientRect().height;
        setHomeHeroOwnsBrand(heroBottom > navHeight + 8);
      });
    };

    updateBrandState();
    window.addEventListener("scroll", updateBrandState, { passive: true });
    window.addEventListener("resize", updateBrandState);
    return () => {
      cancelAnimationFrame(animationFrame);
      window.removeEventListener("scroll", updateBrandState);
      window.removeEventListener("resize", updateBrandState);
    };
  }, [location.pathname]);

  return (
    <header
      className={`site-nav${homeHeroOwnsBrand ? " site-nav--brand-hidden" : ""}`}
      aria-label="Magdump navigation"
    >
      <Link className="nav-brand" to="/" aria-label="Magdump home">
        <img src={transparentLogo} alt="Magdump" draggable="false" />
      </Link>
      <nav>
        {navItems.map((item) => (
          <NavLink key={item.to} to={item.to}>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="social-row" aria-label="Social contact shortcuts">
        {socialLinks.map((item) => (
          <SocialIconLink key={item.label} {...item} />
        ))}
        <button
          className="icon-button mobile-menu-trigger"
          type="button"
          aria-label="Open mobile navigation"
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen(true)}
        >
          <FiMenu aria-hidden="true" />
        </button>
      </div>
      <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
    </header>
  );
}
